import React from 'react';
import { PresentationChartBarIcon, QueueListIcon, StarIcon, ChartBarIcon, Squares2X2Icon } from '@heroicons/react/24/solid';

const NavbarMiddle = ({ activeTabL1, setActiveTabL1, activeTabL2 }) => {
  // Board | Detailed | Manage — padronizado para Flow, Budget e Assets
  const boardDetailedManageTabs = [
    { id: 'board', label: 'Board', Icon: PresentationChartBarIcon },
    { id: 'detailed', label: 'Detailed', Icon: QueueListIcon },
    { id: 'manage', label: 'Manage', Icon: Squares2X2Icon },
  ];

  const getSubtabs = () => {
    const overviewTab = { id: 'overview', label: 'Overview', Icon: ChartBarIcon };
    const extraTab = { id: 'extras', label: 'Extras', Icon: StarIcon };

    if (activeTabL2 === 'home') {
      return [overviewTab, extraTab];
    }
    if (activeTabL2 === 'flow' || activeTabL2 === 'budget' || activeTabL2 === 'assets') {
      return boardDetailedManageTabs;
    }
    return boardDetailedManageTabs;
  };

  const subtabs = getSubtabs();

  return (
    <div className="w-full flex justify-center fixed top-16 left-0 z-10 pb-2">
      <div className="bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-sm inline-flex gap-4">
        {subtabs.map(({ id, label, Icon }) => (
          <button
            key={id}
            onClick={() => setActiveTabL1(id)}
            className={`flex items-center gap-2 text-xs px-4 py-1.5 rounded-full transition-colors ${
              activeTabL1 === id
                ? 'bg-green-800 text-white'
                : 'hover:bg-gray-100 text-gray-700'
            }`}
          >
            <Icon className="h-4 w-4" />
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NavbarMiddle;
